module.exports = __webpack_public_path__ + "img/33_2.0277cda2.png";